import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32e03860"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_bulk_modal_active",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "newTargetCloneModalRef",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-100 mw-lg-50" }
const _hoisted_3 = { class: "modal-content mx-md-15" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy fs-3 text-primary" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body py-lg-5 px-lg-7 mh-700px scroll-y bg-light" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "form mb-5" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = { value: "ACTIVE" }
const _hoisted_13 = { value: "INACTIVE" }
const _hoisted_14 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_15 = ["data-kt-indicator"]
const _hoisted_16 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_17 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_18 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_modal-bulk_active_user",
          onSubmit: _ctx.submitModalData,
          ref: "cloneSiteRef",
          class: "form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.translate("pages.user.userBulkTitle")), 1)
              ]),
              _createElementVNode("div", {
                class: "btn btn-sm btn-icon btn-active-color-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)), ["stop"]))
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate("common.status")), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status) = $event)),
                      class: "form-select",
                      "data-placeholder": "Select",
                      disabled: ""
                    }, [
                      _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.translate("common.active")), 1),
                      _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.translate("common.inactive")), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.status]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "reset",
                id: "site_clone_cancel",
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                "data-bs-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["stop"]))
              }, _toDisplayString(_ctx.translate("common.close")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate("common.save")), 1),
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_ctx.translate("common.pleaseWait")) + " ", 1),
                      _hoisted_19
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_15)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ], 512))
}